const validGroupName = input => {
  return input.trim().length > 0
}

export default validGroupName
